import React from 'react';
import './ZoomButtons.scss';
import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';
import { useZoomContext } from 'utils/components/Zoom/ZoomContext';

export interface ZoomProps {
    zoomLabel?: string;
    allowZoomOut?: boolean;
}
export default function ZoomButtons(props: ZoomProps) {
    const { zoomLabel, allowZoomOut } = props;

    const { transform, zoomIn, zoomOut } = useZoomContext();

    const zoomedIn = transform.k > 1;
    const zoomedOut = transform.k < 1;
    const zoomOutEnabled = zoomedIn || allowZoomOut;

    return (
        <>
            <ToolbarIcon name="zoom-in" onClick={zoomIn} active={zoomedIn} />
            <span className="zoom-label">{zoomLabel}</span>
            <ToolbarIcon
                name="zoom-out"
                onClick={zoomOut}
                disabled={!zoomOutEnabled}
                active={zoomedOut}
            />
        </>
    );
}
